export const environment = {
  production: true,
  accessControlApiPath: 'web/components-api/access-control',
  appName: 'Document Engine',
  baseUrl: '',
  context: '/dpsinclair',
  cookieName: 'dpsinclair',
  hostname: '',
  port: '',
  webApiPath: 'rest'
};
